import { z } from 'zod';

import { ChildAvailabilityZod } from '../dotcom/children/zod.ts';
import {
  LeadChurch,
  LeadContact,
  LeadEvent,
  LeadHost,
} from '../dotcom/proxy-api/leads.ts';
import { NavigationProps } from './schema.ts';

export const HeaderProps: z.ZodType<HeaderProps> = z.object({
  primaryMenu: NavigationProps,
});
export type HeaderProps = {
  primaryMenu: NavigationProps;
};

export const FooterProps: z.ZodType<FooterProps> = z.object({
  footerMenuPrimary: NavigationProps.optional(),
  footerMenuSecondary: NavigationProps.optional(),
  footerMenuSocial: NavigationProps.optional(),
  footerMenuTrust: NavigationProps.optional(),
});
export type FooterProps = {
  footerMenuPrimary?: NavigationProps;
  footerMenuSecondary?: NavigationProps;
  footerMenuSocial?: NavigationProps;
  footerMenuTrust?: NavigationProps;
};

/** Forms * */
const SubscriptionRequest = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  subscriptionCode: z.string().optional(),
  isFirstNameRequired: z.boolean().optional(),
  isLastNameRequired: z.boolean().optional(),
});
export type SubscriptionRequest = z.infer<typeof SubscriptionRequest>;

const LeadBase = z.object({
  leadType: z.string().optional(),
  comments: z.string().optional(),
});

export const LeadChurchRequest = LeadBase.merge(LeadContact).merge(LeadChurch);
export type LeadChurchRequest = z.infer<typeof LeadChurchRequest>;

export const LeadEventRequest = LeadBase.merge(LeadHost).merge(LeadEvent);
export type LeadEventRequest = z.infer<typeof LeadEventRequest>;

/** Compassion Sunday * */
export const CompassionSundayBaseFormData = LeadBase.merge(LeadHost);
export type CompassionSundayBaseFormData = z.infer<
  typeof CompassionSundayBaseFormData
>;

export const CompassionSundayRegistrationFormData =
  LeadBase.merge(LeadEvent).merge(LeadHost);
export type CompassionSundayRegistrationFormData = z.infer<
  typeof CompassionSundayRegistrationFormData
>;

export const ChildAvailabilitySearchResultsSchema = z.object({
  children: z.array(ChildAvailabilityZod),
});
